
<div class="row mb-2" *ngIf="isAHR && reviewerType === 'AHR' && !loading">
    <div class="col-md-12 text-right">
        <button type="button" class="btn btn-outline-primary btn-sm mr-1" [disabled]="!getVisibleAdvancementCases().length" (click)="selectAllCases(ADVANCEMENT_CASES)">{{selAllAdv ? 'Unselect' : 'Select'}} All Advancements</button>
        <button type="button" class="btn btn-outline-primary btn-sm mr-1" [disabled]="!getVisibleEvaluationCases().length" (click)="selectAllCases(AE_CASES)">{{selAllEvals ? 'Unselect' : 'Select'}} All Annual Evals</button>
        <button type="button" class="btn btn-outline-primary btn-sm mr-1" [disabled]="selectedFileCount <= 0" (click)="downloadSelectedCases()">
            Download <span *ngIf="selectedFileCount > 0">({{selectedFileCount}})</span>
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm mr-1" (click)="updateShowSeparatedAcademics()">{{shwSeparatedAcademics ? 'Hide' : 'Show'}} Separated Academics</button>
    </div>
</div>

<!-- Reusable filter dropdown template -->
<ng-template #roleFilterDropdownTemplate>
    <mat-form-field *ngIf="myRoles?.size > 1" appearance="fill" class="w-100" subscriptSizing="dynamic">
        <mat-label><i class="fa fa-filter mr-2"></i>Filter by 'My Role'</mat-label>
        <mat-select [formControl]="reviewerRoles" multiple>
            <mat-option *ngFor="let role of myRoles" [value]="role">
                {{role}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</ng-template>

<!-- Reusable sort buttons template -->
<ng-template #sortButtonsTemplate>
    <small class="mr-2">Sort:</small>
    <button type="button" class="btn btn-sm mr-1" 
        [ngClass]="{'btn-primary': sortBy === 'firstName', 'btn-outline-secondary': sortBy !== 'firstName'}"
        (click)="toggleSort('firstName')">
        First <i class="fa" [ngClass]="{'fa-arrow-up': sortBy === 'firstName' && sortDirection === 'asc', 'fa-arrow-down': sortBy === 'firstName' && sortDirection === 'desc'}"></i>
    </button>
    <button type="button" class="btn btn-sm"
        [ngClass]="{'btn-primary': sortBy === 'lastName', 'btn-outline-secondary': sortBy !== 'lastName'}"
        (click)="toggleSort('lastName')">
        Last <i class="fa" [ngClass]="{'fa-arrow-up': sortBy === 'lastName' && sortDirection === 'asc', 'fa-arrow-down': sortBy === 'lastName' && sortDirection === 'desc'}"></i>
    </button>
</ng-template>

<!-- mobile view -->
<div class="card d-lg-none d-block">
    <div class="card-header">
        Your program review cases
    </div>

    <!-- Filter by role dropdown -->
    <ng-container *ngTemplateOutlet="roleFilterDropdownTemplate"></ng-container>

    <select class="form-control" [(ngModel)]="selectedCaseIdForMenu">
        <option [ngValue]="null" disabled selected>
            Select a case to review
        <option *ngFor="let c of filteredCases" [ngValue]="c.id">
            {{c.candidateName}}
            - {{c.roles}} 
        </option>
    </select>

    <ng-container *ngIf="!loading && cases.length > 1"> 
        <!-- Sort buttons -->
        <div class="row align-items-center">
            <div class="col-auto ml-auto m-1">
                <ng-container *ngTemplateOutlet="sortButtonsTemplate"></ng-container>
            </div>
        </div>
    </ng-container>
</div>

<!-- desktop view -->
<div class="card d-lg-block d-none">
    <div class="card-header" *ngIf="cases.length > 0" style="padding-left: 0.9rem; display: flow-root;">
        Your program review cases
        <mat-button-toggle-group *ngIf="isAHR" #toggleBtn="matButtonToggleGroup" (change)="reviewerTypeChanged($event.value)" [value]="reviewerType">
            <mat-button-toggle value="AHR">
                AHR
            </mat-button-toggle>
            <mat-button-toggle value="Reviewer">
                Reviewer
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <ng-container *ngIf="!loading && cases.length > 1">        
        <!-- Filter by role dropdown -->
        <ng-container *ngTemplateOutlet="roleFilterDropdownTemplate"></ng-container>

        <div class="card-header p-0">
            <div class="row align-items-center">
                <!-- Search Academic input -->
                <div class="col">
                    <mat-form-field appearance="fill" class="w-100" subscriptSizing="dynamic">
                        <mat-label><i class="fa fa-search text-muted mr-2"></i>Search Academic</mat-label>
                        <input matInput type="text" [formControl]="searchByName">
                        <button *ngIf="searchByName.value" matSuffix style="background: none; border: none; cursor: pointer;"
                            aria-label="Clear" (click)="searchByName.setValue('')">
                            <i class="fa fa-times text-secondary mr-2"></i>
                        </button>
                    </mat-form-field>
                </div>
                
                <!-- Sort buttons -->
                <div class="col-auto ml-auto m-1">
                    <ng-container *ngTemplateOutlet="sortButtonsTemplate"></ng-container>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="list-group scroll-y">
        <div *ngIf="!loading && cases.length === 0" class="list-group-item text-center">
            You have no cases to review
        </div>
        <div *ngIf="!loading && cases.length > 0 && filteredCases.length === 0" class="list-group-item text-center">
            No cases match your search or filter
        </div>
        <div *ngIf="loading">
            <i class="fa fa-fw fa-spin fa-refresh"></i>
            Loading...
        </div>
        <div
            *ngFor="let c of filteredCases"
            [ngClass]="{
                'text-sm':true,
                'list-group-item list-group-item-action': true,
                'active': !!c.id.equals(selectedCaseId)
            }"
            [ngStyle]="!c.id.equals(selectedCaseId) && isSeparatedAcademic(c) ? {'background-color': 'lightgray', 'cursor': 'pointer'} : {'cursor': 'pointer'}">
            <span class="media"> 
                <span class="media-body" [routerLink]="[c.id.workflowCaseId]">
                    <small *ngIf="isSeparatedAcademic(c)"><i class="fa fa-exclamation-circle text-danger"></i></small>
                    {{c.candidateName}} 
                    <small *ngIf="isSeparatedAcademic(c)">(Separated {{ c.separationDate | date:'mediumDate' }})</small>
                    <br>
                    <span class="text-sm">
                        {{c.roles}}
                        <br>
                        {{c.progress}}
                    </span>
                </span>
                <span *ngIf="isAHR && reviewerType === 'AHR' && c.proposedAction && isSelectableCase(c.proposedAction.type)">
                    <input class="form-check-input" id="checkboxNoLabel" [(ngModel)]="c.isChecked" (ngModelChange)="countChecked()" type="checkbox" value={{c.id.academicId} >
                </span>
            </span>

        </div>
    </div>
</div>